import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { AboutComponent } from './about.component';

const log = new LoggingService();

export const AboutRoute: Ng2StateDeclaration = {
    // name: 'Account.**'
    name: 'about',
    url: '/about',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.AccountModule)
    data: { requiresAuth: true },
    component: AboutComponent
};
